import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  template: `
    <h2>¿Estás seguro?</h2>
    <p>A continuación se va limpiar el carrito y quedará sin ningún producto agregado, desea confirmar?</p>
    <button mat-button (click)="onConfirm()">Confirmar</button>
    <button mat-button (click)="onCancel()">Cancelar</button>
  `,
})
export class ConfirmComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmComponent>) { }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
